// TODO: сделать базовый url при доступности бэка
import axios from 'axios';
import Cookies from 'js-cookie';
import i18n from 'i18next';

import {LOCAL_STORAGE_CALC_STAND_KEY} from './constants';

export const calcStand =
  window.localStorage.getItem(LOCAL_STORAGE_CALC_STAND_KEY) || `${import.meta.env.VITE_APP_API}/calc-api`;

const formulaHttp = axios.create({
  baseURL: `${calcStand}/api`,
  timeout: 30000,
});
const getLang = (lang: string) => (lang === 'ru' ? 'ru-RU' : 'en');

formulaHttp.interceptors.request.use(
  config => {
    // Do something before request is sent
    const token = Cookies.get('token');
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
      config.headers['Accept-Language'] = getLang(i18n.language);
    }
    return config;
  },
  error => {
    throw new Error(JSON.stringify(error.response.data));
  }
);

formulaHttp.interceptors.response.use(
  response => {
    return response.data;
  },
  error => {
    throw new Error(JSON.stringify(error.response.data));
  }
);

export default formulaHttp;
